import { Button, Form, Input, Modal } from "antd";
import React from "react";
import { FormattedMessage, injectIntl } from "react-intl";

/**
 * Stripe needs an email before it will open a connected account, but a payee
 * invited by SMS has none. Collect it here so they can finish payout setup
 * instead of hitting a dead end on the way to getting paid.
 */
const PayoutEmailModal = ({ open, loading, onSubmit, onCancel, intl }) => {
  const [form] = Form.useForm();

  const handleFinish = ({ email }) => onSubmit(email?.trim());

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      footer={null}
      maskClosable={false}
      className="p-3"
    >
      <div className="fw-bolder fs-5 mb-3">
        <FormattedMessage id="PAYOUT_EMAIL_PROMPT_TITLE" />
      </div>
      <div className="mb-3">
        <FormattedMessage id="PAYOUT_EMAIL_PROMPT_BODY" />
      </div>
      <Form form={form} onFinish={handleFinish} layout="vertical">
        <Form.Item
          name="email"
          label={intl.formatMessage({ id: "email" })}
          rules={[
            {
              type: "email",
              message: `${intl.formatMessage({ id: "valid_email" })}`,
            },
            {
              required: true,
              message: `${intl.formatMessage({ id: "email_required" })}`,
            },
          ]}
        >
          <Input
            type="email"
            data-testid="payout-email-input"
            placeholder={`${intl.formatMessage({ id: "email" })}`}
            className="input-field"
          />
        </Form.Item>
        <div className="d-flex justify-content-end">
          <Button className="mx-1" onClick={onCancel} disabled={loading}>
            <FormattedMessage id="cancel" />
          </Button>
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            data-testid="payout-email-submit"
          >
            <FormattedMessage id="save" />
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default injectIntl(PayoutEmailModal);
